import { loggerContext } from './loggerContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Provides a logger instance to React components.
 *
 * @param props LoggerContextProviderProps
 */
export const LoggerProvider = ({
  children,
  logger
}) => /*#__PURE__*/_jsx(loggerContext.Provider, {
  value: logger,
  children: children
});
//# sourceMappingURL=LoggerProvider.js.map